import { Box, Typography, Image } from "@jewlr/storybook/core"
import styled from "styled-components"

export const StaticSectionTitle = styled(Typography).attrs((props) => ({
  as: "h2",
  bold: true,
  color: "black",
  fontSize: "20px",
  fontWeight: "normal",
  mb: "20px",
  mt: "20px",
  textAlign: { _: "center", tablet: "left" },
  ...props,
}))``

export const Section = styled(Box).attrs((props) => ({
  bg: "white",
  pb: { _: 0, tablet: 6 },
  pt: { _: 4, tablet: 6 },
  ...props,
}))``

export const SectionTitle = styled(Typography).attrs((props) => ({
  as: "h2",
  fontSize: { _: "20px", tablet: "24px" },
  fontWeight: "500",
  lineHeight: "28px",
  textAlign: "center",
  textTransform: "uppercase",
  ...props,
}))``

export const Text = styled(Typography).attrs((props) => ({
  fontSize: "16px",
  fontWeight: "300",
  letterSpacing: "-0.02em",
  lineHeight: "22px",
  ...props,
}))``

export const StyledImage = styled(Image).attrs((props) => ({
  height: props.height || "auto",
  maxWidth: { desktop: "500px", tablet: "325px" },
  width: props.width || "100%",
  ...props,
}))`
  display: block;
  margin: ${(props) =>
    props.marginRight ? `0 ${props.marginRight}px 0 0` : "0 auto"};
  opacity: ${(props) => (props.blur ? "0" : "1")};
  transition: opacity 0.3s ease;
`

export const Footnote = styled(Box).attrs({
  bg: "rgba(37, 104, 178, 0.05)",
  my: "10px",
  py: 1,
  textAlign: "center",
})``

export const FootnoteText = styled(Typography).attrs({
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "-0.02em",
  lineHeight: "14px",
  maxWidth: "240px",
  mx: "auto",
})``
